import { render } from "./Feedback.vue?vue&type=template&id=9ffeefae"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=9ffeefae&lang=scss"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__